import { FrontendProductSchema } from "@redotech/redo-model/agents/support-agents/frontend-product";
import * as z from "zod/v4";

export const getBestSellers = {
  name: "getBestSellers" as const,
  input: z.object({ limit: z.number().optional() }),
  output: z.array(FrontendProductSchema),
};
